export const RESET_LICENSE = "RESET_LICENSE";
export const SET_PROCESSING = "SET_PROCESSING";
export const STOP_PROCESSING = "STOP_PROCESSING";
export const GET_LICENSE = "GET_LICENSE";
export const GET_LICENSES = "GET_LICENSES";
export const SEARCH_LICENSES = "SEARCH_LICENSES";
export const GET_BANKS = "GET_BANKS";
export const UPDATE_LICENSE = "UPDATE_LICENSE";
export const GENERATE_LICENSE = "GENERATE_LICENSE";
export const SET_CURRENT_LICENSE = "SET_CURRENT_LICENSE";
export const ADD_NEW = "ADD_NEW";
export const REMOVE_NEW = "REMOVE_NEW";
export const GET_MODULES = "GET_MODULES";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const LOAD_LICENSE = "LOAD_LICENSE";
